import {
  type FontSize,
  type LineHeight,
  type ThemeGapValue,
  type ThemeSpacing,
  fontSizeToPixels,
  getLineHeightValue,
  spacingToPixels,
} from '@mntn-dev/ui-theme'
import type { MultiselectOptionItem } from './types.ts'

export const optionPadding: ThemeSpacing = '3'
export const optionContentHeight = 28 // checkbox height
export const optionBorderWidth = 1

export const multiselectOptionHeight = () =>
  spacingToPixels(optionPadding) * 2 + optionContentHeight + optionBorderWidth

export const searchInputLeading: LineHeight = '6'
export const searchInputPadding: ThemeSpacing = '3'
export const searchInputFontSize: FontSize = 'sm'

export const multiselectSearchHeight = () => {
  const { relative, value } = getLineHeightValue(searchInputLeading)
  const lineHeight = relative
    ? fontSizeToPixels(searchInputFontSize) * value
    : value

  return lineHeight + 2 * spacingToPixels(searchInputPadding)
}

export function getShowMoreAttributes(
  chipContainer: HTMLDivElement,
  columnGapValue: ThemeGapValue
): [count?: number, offset?: number] {
  const nodes = Array.from(chipContainer.childNodes) as HTMLElement[]

  let totalWidth = 0
  let showMoreIndex: number | undefined
  let showMoreOffset = 0

  for (const [index, node] of nodes.entries()) {
    const last = index === nodes.length - 1
    const availableWidth = last
      ? chipContainer.offsetWidth
      : chipContainer.offsetWidth - 100
    if (totalWidth + node.offsetWidth > availableWidth) {
      if (!node.className.includes('invisible')) {
        node.className += ' invisible'
      }

      if (showMoreIndex === undefined) {
        showMoreOffset = totalWidth
        showMoreIndex = index
      }
    } else {
      node.className = node.className.replace('invisible', '')
      totalWidth += node.offsetWidth + spacingToPixels(columnGapValue)
    }
  }

  return [
    showMoreIndex !== undefined ? nodes.length - showMoreIndex : undefined,
    showMoreOffset,
  ]
}

export const transformOnChange =
  <T>(
    onChange: (items: T[]) => void,
    transform: (item: MultiselectOptionItem) => T
  ) =>
  (items: MultiselectOptionItem[]) => {
    onChange(items.map(transform))
  }

export const getShowMoreTooltip = (
  items: MultiselectOptionItem[],
  showMoreNumber?: number
) => {
  if (!showMoreNumber) {
    return undefined
  }

  return items
    .slice(items.length - showMoreNumber)
    .map((item) => item.name)
    .join(', ')
}
